import { Optional } from './types'

export function addEntity<T extends Object>(entities: Optional<T[]>, entity: T) {
	return [...(entities ?? []), entity]
}
